import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Alert from "components/Common/Alert";
import SVGIcon from "components/Icons/SVGIcon";
import Icon from "components/Icons/Icon";
import Loading from "components/Loading";
import { Button } from "react-bootstrap";

import { contains } from "services/filters/";

import { loadSiteSchedulesStart } from "services/redux/actions/singleSites";

import ReactTable from "react-table";

import conxtdOut from "apis/conxtdOut";

export default function Overrides({ site, enterprise_id, weekdays }) {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.sites.current.schedules.loading);
  const overrideRules = useSelector((state) => state.sites.current.schedules.override);

  const columns = [
    {
      key: "ID",
      Header: "Id",
      id: "id",
      show: false,
      accessor: data => data.id,
    },
    // {
    //   key: "START_DATE",
    //   Header: "Start Date",
    //   id: "start_date",
    //   width: 90,
    //   accessor: data => data.start_date,
    // },
    // {
    //   key: "END_DATE",
    //   Header: "End Date",
    //   id: "end_date",
    //   width: 90,
    //   accessor: data => data.end_date,
    // },
    {
      key: "DATE",
      Header: "Date",
      id: "start_date",
      width: 90,
      accessor: data => data.start_date,
    },
    // {
    //   key: "START_DAY",
    //   Header: "Start Day",
    //   id: "start_day_of_week",
    //   width: 90,
    //   accessor: data => weekdays[data.start_day_of_week-1],
    // },
    // {
    //   key: "END_DAY",
    //   Header: "End Day",
    //   id: "end_day_of_week",
    //   width: 90,
    //   accessor: data => weekdays[data.end_day_of_week-1],
    // },
    {
      key: "DAY",
      Header: "Day",
      id: "day_of_week",
      width: 90,
      accessor: data => weekdays[data.day_of_week-1],
    },
    {
      key: "RULE_TYPE",
      Header: "Type",
      id: "rule_type",
      width: 60,
      accessor: data => {
        const ruleTypeId = Number(data.rule_type_id);

        let ruleName = "";
        if (ruleTypeId === 1) ruleName = "open";
        if (ruleTypeId === 2) ruleName = "close";
        if (ruleTypeId === 4) ruleName = "not expected";
        return ruleName;
      },
      Cell: ({row}) => {
        let iconName = "dash";
        if (row.rule_type === "open") iconName = "unlock";
        if (row.rule_type === "close") iconName = "lock";

        let iconColor = "#2B3E4E";
        if (row.rule_type === "open") iconColor = "#3397DB";
        if (row.rule_type === "close") iconColor = "#28498A";

        return <div className="p-0 d-flex justify-content-center align-items-center">
          <div style={{ width: "2rem", height: "2rem", paddingLeft: "2px" }}>
            <SVGIcon type={iconName} color={iconColor} />
          </div>
        </div>
      },
    },
    {
      key: "IDEAL",
      Header: "Ideal",
      id: "ideal",
      width: 70,
      accessor: data => data.ideal_event_hour,
    },
    {
      key: "EARLY",
      Header: "Early",
      id: "early",
      width: 60,
      accessor: data => data.early_offset,
    },
    {
      key: "LATE",
      Header: "Late",
      id: "late",
      width: 60,
      accessor: data => data.late_offset,
    },
    {
      key: "REMINDER",
      Header: "Reminder",
      id: "reminder",
      width: 85,
      accessor: data => data.reminder,
      Cell: ({row}) => {
        if (row.reminder === 1) {
          return <div><Icon className="fas fa-check" /></div>
        } else {
          return <div></div>
        }
      },
    },
    {
      key: "ACTIONS",
      Header: "Actions",
      className: "actions",
      Cell: ({ original }) => {
        return (
          <Button
            onClick={() => {
              Alert({
                text: `Are you sure you want to delete this rule?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
              }).then(result => {
                if (result.value) {
                  conxtdOut.delete(
                    `/analyticx/scheduler-rules/delete/${original.id}`,
                    {
                      rule_type_id: original.rule_type_id,
                      sudo_site_id: site.sudo_site_id,
                    }
                  ).then((response) => {
                    if (response.status === 200) {
                      Alert({
                        text: "Rule deleted successfully",
                        icon: "success",
                        timerProgressBar: true,
                        timer: 3000,
                      });
                    };

                    dispatch(loadSiteSchedulesStart({
                      sudo_site_id: site.sudo_site_id,
                      enterprise_id: enterprise_id,
                    }));

                  }).catch((error) => {
                    console.log("error", error.message);
                    Alert({
                      text: "Failed to delete rule, please try again later.",
                      icon: "error",
                      timerProgressBar: true,
                      timer: 5000,
                    });
                  })
                }
              })
            }}
          >Delete</Button>
        )
      },
    },
  ];

  return loading
    ? <div className="pt-4"><Loading center /></div>
    : <>
      <div className="card visual-data">
        <ReactTable
          filterable
          noDataText="No data available..."
          defaultPageSize={10}
          defaultSorted={[
            {
              id: "start_date",
              desc: false
            }
          ]}
          defaultFilterMethod={(filter, row) => {
            return contains({
              filter: filter.value,
              value: String(row[filter.id]),
              ignoreCase: true,
            });
          }}
          data={overrideRules || []}
          columns={columns}
        />
      </div>
    </>
}